import { createSelector } from '@ngrx/store';

import { ICitation } from '../../models';
import { getCitation } from './get.citations';

export const getNumberedCitations = createSelector(
  [getCitation],
  ({ references }): ICitation[] => references
);
